import { render, staticRenderFns } from "./person-avatar.vue?vue&type=template&id=6dd0f686&"
import script from "./person-avatar.vue?vue&type=script&lang=js&"
export * from "./person-avatar.vue?vue&type=script&lang=js&"
import style0 from "./person-avatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "person-avatar.vue"
export default component.exports